import script from "./FullPagePDF.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullPagePDF.vue?vue&type=script&setup=true&lang=ts"

import "./FullPagePDF.vue?vue&type=style&index=0&id=7a8a71ae&scoped=true&lang=scss"
import "./FullPagePDF.vue?vue&type=style&index=1&id=7a8a71ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8a71ae"]])

export default __exports__